module.exports = __webpack_public_path__ + "static/media/concert.50c71aaa.jpg";